<div class="">
  <div class="wrap_body">
    <div class="">
      <div *ngIf="!isHideFilter">
        <form [formGroup]="pastFilterForm">
          <!-- <div class="row">
            <div class="col-12 d-flex align-items-center justify-content-between">
              <h5 class="mb-0">Past Clients</h5>
              <button color="primary" mat-flat-button (click)="addToCampaign()">Add to Campaign</button>
            </div>
          </div> -->
          <div class="filter-section px-3 m-filter">
            <div class="row mb-3">
              <div class="col-lg-3 col-md-3 col-sm-6 col-12 pl-md-0">
                <mat-form-field class="mr-5 w-100">
                  <mat-label> Name </mat-label>
                  <input
                    matInput
                    autocomplete="off"
                    formControlName="searchClients"
                    type="text"
                    placeholder="Search Name,Email,City"
                  />
                </mat-form-field>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                <mat-form-field class="ltv w-100">
                  <mat-label>Transaction Type</mat-label>
                  <mat-select formControlName="transactionType">
                    <mat-option *ngFor="let val of transactionType" [value]="val">{{ val }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                <mat-form-field class="ltv w-100">
                  <mat-label>LTV (%)</mat-label>

                  <input
                    matInput
                    readonly
                    [value]="ltvDisplayValue || 'Select range'"
                    #ltvTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="ltvMenu"
                  />

                  <mat-menu #ltvMenu="matMenu" class="ltv-range-panel">
                    <div class="range-container" (click)="$event.stopPropagation()">
                      <div class="range-header">
                        <span><b>Select LTV Range</b></span>
                        <button mat-icon-button (click)="ltvTrigger.closeMenu()">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                      <div class="range-row">
                        <mat-form-field appearance="outline" class="w-100 mb-2">
                          <mat-label>Min LTV</mat-label>
                          <input matInput type="number" formControlName="ltvMin" min="0" max="100" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Max LTV</mat-label>
                          <input matInput type="number" formControlName="ltvMax" min="0" max="100" />
                        </mat-form-field>
                      </div>

                      <mat-error
                        *ngIf="
                          pastFilterForm.get('ltvMin')?.hasError('max') || pastFilterForm.get('ltvMax')?.hasError('max')
                        "
                      >
                        LTV cannot be greater than 100
                      </mat-error>
                      <mat-error *ngIf="pastFilterForm.get('ltvMax')?.hasError('ltvRangeInvalid')">
                        Max LTV must be greater than Min LTV
                      </mat-error>
                    </div>
                  </mat-menu>
                </mat-form-field>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                <mat-form-field class="owned w-100">
                  <mat-label>Owned (Years)</mat-label>

                  <input
                    matInput
                    [value]="ownedDisplayValue || 'Select range'"
                    readonly
                    [matMenuTriggerFor]="ownedMenu"
                    #ownedTrigger="matMenuTrigger"
                  />

                  <mat-menu #ownedMenu="matMenu" class="owned-range-panel">
                    <div class="range-container" (click)="$event.stopPropagation()">
                      <div class="range-header">
                        <span><b>Select Owner Range</b></span>
                        <button mat-icon-button (click)="ownedTrigger.closeMenu()">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                      <div class="range-row">
                        <mat-form-field appearance="outline" class="w-100 mb-2">
                          <mat-label>Min</mat-label>
                          <input matInput type="number" formControlName="ownedMin" min="0" max="20" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Max</mat-label>
                          <input matInput type="number" formControlName="ownedMax" min="0" max="20" />
                        </mat-form-field>
                      </div>
                      <mat-error
                        *ngIf="
                          pastFilterForm.get('ownedMin')?.hasError('max') ||
                          pastFilterForm.get('ownedMax')?.hasError('max')
                        "
                      >
                        Owned Years cannot be greater than 20
                      </mat-error>
                      <mat-error *ngIf="pastFilterForm.get('ownedMax')?.hasError('ownedRangeInvalid')">
                        Max Owned Years must be greater than Min Owned Years
                      </mat-error>
                    </div>
                  </mat-menu>
                </mat-form-field>
              </div>

              <div class="col-md-3 col-sm-6 col-12 px-0 mt-2">
                <button color="primary" mat-flat-button (click)="filterData()" class="ml-auto ml-lg-0">Filter</button>
                <button mat-button color="primary" class="ml-2" mat-stroked-button (click)="resetFilter()">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="row mb-3">
        <div class="col-lg-12 mt-2 dash_list">
          <div class="">
            <div class="table-responsive table_wrap" #clientListContainer>
              <table mat-table #sortedTable matSort class="mat-elevation-z2 w-100" [dataSource]="tableDataSource">
                <!-- <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="sticky-select1"></th>
                  <td mat-cell *matCellDef="let row" class="sticky-select">
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="toggleRow(row, $event)"
                      [checked]="selection.has(row)"
                      color="primary"
                    >
                    </mat-checkbox>
                  </td>
                </ng-container> -->

                <!-- Transaction Type -->
                <ng-container matColumnDef="transactionType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Type</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.transactionType || '—' }}
                  </td>
                </ng-container>

                <!-- Client Name -->
                <ng-container matColumnDef="clientName">
                  <th mat-header-cell *matHeaderCellDef>Client Name</th>
                  <td mat-cell *matCellDef="let element" class="capitalize">
                    {{
                      getFullNames(
                        { first: element.clientOneFirstName, last: element.clientOneLastName },
                        { first: element.clientTwoFirstName, last: element.clientTwoLastName },
                        { first: element.clientThreeFirstName, last: element.clientThreeLastName }
                      )
                    }}
                  </td>
                </ng-container>

                <!-- Name -->
                <ng-container matColumnDef="currentOwner">
                  <th mat-header-cell *matHeaderCellDef>Current Owner</th>
                  <td mat-cell *matCellDef="let element" class="capitalize">
                    {{
                      getFullNames(
                        { first: element.currentOwnerOneFirstName, last: element.currentOwnerOneLastName },
                        { first: element.currentOwnerTwoFirstName, last: element.currentOwnerTwoLastName },
                        { first: element.currentOwnerThreeFirstName, last: element.currentOwnerThreeLastName }
                      )
                    }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="transactionDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.closeDate ? (element.closeDate | simpleDate) : '--' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef>Property Address</th>
                  <!-- [propertyAddress]="element.address" -->

                  <td mat-cell *matCellDef="let element">
                    <span
                      *ngIf="getAddressComponentsFromStandardAddress(element.address) as addr"
                      (click)="viewProperty(addr); $event.stopPropagation()"
                    >
                      <b
                        ><div class="street">{{ addr.StreetAddress }}</div></b
                      >
                      <div class="city">{{ addr.City }} {{ addr.State }} {{ addr.PostalCode }}</div>
                    </span>
                  </td></ng-container
                >

                <!-- Occupancy -->
                <ng-container matColumnDef="occupancy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Occupancy</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.occupancy || '—' }}
                  </td>
                </ng-container>

                <!-- Current Status -->
                <ng-container matColumnDef="currentStatus">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.currentStatus || '—' }}
                  </td>
                </ng-container>

                <!-- Current Value -->
                <ng-container matColumnDef="currentValue">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Value</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatAmount(element.currentValue  ||  '—') }}
                    <!-- {{ element.currentValue ? (element.currentValue | currency: 'USD':'symbol':'1.0-0') : '—' }} -->
                  </td>
                </ng-container>
                <!-- Appreciation -->
                <!-- <ng-container matColumnDef="appreciation">
                  <th mat-header-cell *matHeaderCellDef>Appreciation</th>
                  <td mat-cell *matCellDef="let element">
                    <span
                      *ngIf="
                        isHideFilter == false && element.appreciation !== null && element.appreciation !== undefined
                      "
                      class="value-wrapper"
                      [ngClass]="{
                        'text-green': +element.appreciation > 0,
                        'text-red': +element.appreciation < 0
                      }"
                    >
                      <b class="appreciation-pos" *ngIf="+element.appreciation > 0">
                        <img src="assets/images/rise.png" height="16px" />
                        {{ element.appreciation ? element.appreciation + '%' : '-' }}
                      </b>
                      <b class="appreciation-neg" *ngIf="+element.appreciation < 0">
                        <img src="assets/images/down.png" height="16px" />
                        {{ element.appreciation ? element.appreciation + '%' : '-' }}
                      </b>
                    </span>
                  </td>
                </ng-container> -->

                <!-- Equity -->
                <ng-container matColumnDef="equity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Equity</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.equity ? element.equity + '%' : '—' }}
                  </td>
                </ng-container>

                <!-- LTV -->
                <ng-container matColumnDef="ltv">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>LTV</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.ltv ? element.ltv + '%' : '-' }}
                  </td>
                </ng-container>

                <!-- Owned For -->
                <ng-container matColumnDef="ownedFor">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Owned For</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.ownedFor || '--' }}
                  </td>
                </ng-container>
                <!-- Action -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <!-- <button
                      mat-icon-button
                      color="primary"
                      matTooltip="Update contact"
                      (click)="actions('addContact', element)"
                    >
                      <mat-icon>person_add</mat-icon>
                    </button> -->
                    <button
                      mat-icon-button
                      color="primary"
                      matTooltip="Send Mail"
                      (click)="actions('sendMail', element); $event.stopPropagation()"
                    >
                      <mat-icon>mail</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: tableColumnList" (click)="actions('addContact', row)"></tr>
              </table>
            </div>

            <div class="flex_center w-100" *ngIf="!pastUsersCount">
              <div class="notFound text-center noData">
                <div>
                  <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                  <h4>No past clients found</h4>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center" *ngIf="!limitRows">
              <!-- <button type="button" mat-button color="primary" class="ml-3 m-export">
                <mat-icon [inline]="true">bar_chart</mat-icon>
                Analyze Transactions
              </button> -->
              <!-- <button
                color="primary"
                *ngIf="selectedRows?.length > 0"
                mat-flat-button
                (click)="addToCampaign()"
                class=""
                style="min-width: 170px"
              >
                Automate Marketing
              </button> -->
              <mat-paginator
                class="d-inline-block w-100 m-wdh"
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 25, 50]"
                showFirstLastButtons
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="section-in-progress" *ngIf="isDataLoading">
      <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
      Please wait while we load
    </div> -->
  </div>
  <!-- <ng-template #inviteInvestorDialog>
    <button class="close" mat-button type="button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </ng-template> -->
</div>
<app-create-mail-sheet *ngIf="openCreateMailSheetValue"></app-create-mail-sheet>
<app-add-contact-note-sheet *ngIf="openAddContactNoteSheetValue"></app-add-contact-note-sheet>